// A string cut to fit, at a word boundary, with an ellipsis.
//
// Dependency-free on purpose: the Worker caps a Polizei Thema with it
// (`citynews.ts`) and the app caps Today's one news fact with it
// (`screens/Today.tsx`), the way `Places.tsx` already reaches into
// `src/districts.ts`. Both callers pass their own `max`, so neither decides
// the other's length — the cap is an argument, not a shared constant.

/**
 * Where to cut `text` so that what is left, plus a one-character ellipsis,
 * is at most `max` characters: the last space inside that room, unless the
 * text is one unbroken run (a URL, a hashtag chain), in which case the cut
 * lands mid-word rather than throwing nearly everything away. Only called
 * for text that is actually over `max`.
 */
export function wordCut(text: string, max: number): number {
  const room = Math.max(1, max - 1);
  if (text[room] === ' ') return room;
  const sp = text.lastIndexOf(' ', room);
  return sp >= room * 0.4 ? sp : room;
}

/** Trailing characters a cut must not leave hanging: a comma, a dash that
 *  opened a clause, a bracket or quote that nothing closes. */
const DANGLING = /[\s,;:–—\-(\[«„"'‚/]+$/;

export function clampAtWord(text: string, max: number): string {
  const s = text.replace(/\s+/g, ' ').trim();
  if (s.length <= max) return s;
  return `${s.slice(0, wordCut(s, max)).replace(DANGLING, '')}…`;
}
